export default __webpack_public_path__ + "static/media/Silver.64813ae7.svg";